import Media from './Media';

export { default as MediaTheme } from './Media.style';
export default Media;
